var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2179 2.92849C12.5079 -0.976165 6.49212 -0.976165 2.78207 2.92849C-0.927356 6.83381 -0.927356 13.1662 2.78207 17.0715C6.49212 20.9762 12.5079 20.9762 16.2179 17.0715C19.9274 13.1662 19.9274 6.83381 16.2179 2.92849ZM13.3654 14.8996C12.5981 14.4335 8.44079 11.9121 8.44079 11.9121H8.40383C8.40383 11.9121 8.40383 4.61247 8.40383 3.60433C8.40383 2.59618 9.90715 2.55992 9.90715 3.60433C9.90715 4.64873 9.90715 10.9646 9.90715 10.9646C9.90715 10.9646 13.1837 12.9222 14.117 13.5236C15.0504 14.1249 14.1327 15.3664 13.3654 14.8996Z",
    fill: "#62676E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.5df0a9dd.svg";
export { ForwardRef as ReactComponent };